import { render, staticRenderFns } from "./AITranscription.vue?vue&type=template&id=43baa40a&scoped=true"
import script from "./AITranscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./AITranscription.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AITranscription.vue?vue&type=style&index=0&id=43baa40a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43baa40a",
  null
  
)

export default component.exports